/**
 * Admin page rendered at "/admin/users" (nested route inside AdminHomepage, which is
 * mounted at "/admin/*" behind an admin-only ProtectedRoute). Shows a single "users"
 * tab containing a read-only PaginatedList of user accounts (itemType "user");
 * rows are not clickable since no onItemClick handler is provided.
 */
import PaginatedList from "@/components/PaginatedList";
import TabbedPage from "@/components/TabbedPage";
import React from "react";

const UsersAdminPage: React.FC = () => {
    return (
        <TabbedPage
            tabs={[{ tabName: "users", render: () => <PaginatedList itemType="user" /> }]}
        />
    );
};

export default UsersAdminPage;
